'use client';

import Image from 'next/image';
import Link from 'next/link';

const testimonials = [
  {
    image: '/images/customer-1.png',
    name: 'Amara Osei-Bonsu',
    role: 'CFO, FinBridge Ghana',
    quote:
      'We expanded from Nigeria to Ghana and Avetium made the compliance side invisible. We just paid people — they handled everything else.',
  },
  {
    image: '/images/customer-2.png',
    name: 'Chidi Nwosu',
    role: 'Head of People, Kobo360',
    quote:
      'Finally a payroll tool that understands PAYE, NHF, and NSITF without us having to explain them on every support call.',
  },
  {
    image: '/images/customer-3.png',
    name: 'Abena Mensah',
    role: 'Operations Director, PayFlex',
    quote:
      'The self-service portal alone saved us 4 hours a week of HR admin. Employees love having their own payslip history accessible.',
  },
  {
    image: '/images/customer-4.png',
    name: 'Tunde Bello',
    role: 'Finance Officer, Avetium',
    quote:
      'It’s easy to process payment approval, process made easy, integration with other applications like Zoho Books, Paystack are seamless.',
  },
];

export default function CustomerReviewSection() {
  return (
    <section className="customer-review-section">

      {/* =====================================================
          CUSTOMER STORIES
          ===================================================== */}
      <div className="customer-review-container">

        <div className="customer-review-heading">
          <span className="customer-review-label">
            CUSTOMER STORIES
          </span>

          <h2>
            Trusted by teams building across Africa.
          </h2>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((testimonial) => (
            <article
              className="testimonial-card"
              key={testimonial.name}
            >

              {/* STARS */}
              <div
                className="testimonial-stars"
                aria-label="5 star review"
              >
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
              </div>

              {/* QUOTE */}
              <p className="testimonial-quote">
                “{testimonial.quote}”
              </p>

              {/* CUSTOMER */}
              <div className="testimonial-customer">

                <div className="testimonial-avatar">
                  <Image
                    src={testimonial.image}
                    alt={testimonial.name}
                    width={40}
                    height={40}
                  />
                </div>

                <div className="testimonial-info">
                  <h3>{testimonial.name}</h3>
                  <p>{testimonial.role}</p>
                </div>

              </div>
            </article>
          ))}
        </div>
      </div>

      {/* =====================================================
          QUESTIONS / CTA
          ===================================================== */}
      <div className="customer-question-section">
        <div className="customer-question-inner">

          <div className="customer-group-image">
            <Image
              src="/images/group-img.png"
              alt="Avetium team"
              width={105}
              height={55}
            />
          </div>

          <h2>
            Still have questions?
          </h2>

          <div className="customer-question-content">

            <p>
              If something isn't covered here, our team is one
              message away.
            </p>

            <Link
              href="/contact"
              className="customer-contact-button"
            >
              Get in touch
            </Link>

          </div>
        </div>
      </div>

    </section>
  );
}
